import React from 'react';
import EventsBase from './Events';

const Events = props => <EventsBase {...props} />;

export default Events;
